var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"nav-link",attrs:{"href":_vm.to},on:{"click":_vm.handleClicked}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }